import React from 'react';
import { LazyComponent } from '@fiverr-private/seller_pages_toolbox';

const lazyImport = () => import(/* webpackChunkName: 'FreelancerPortfolio' */ './PortfolioResolver');

export const LazyPortfolio: React.FC = () => (
    <LazyComponent moduleName="FreelancerPortfolio" lazyImport={lazyImport} componentProps={{}} />
);

export default LazyPortfolio;
